import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b9d97c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personnel-select" }
const _hoisted_2 = { class: "btn-areas" }
const _hoisted_3 = { class: "btn-areas-tags" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("完 成")

import { ref, watch, PropType } from 'vue'
import { useStore } from 'vuex'
import { IPersonnel } from '@/utils/interface'
import {
  fetchRectifyUserPage,
  fetchReviewUserPage,
  fetchCopyUserPage
} from '@/api/shop'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    require: true
  },
  storeNo: {
    type: String,
    require: true
  },
  templateId: {
    type: String,
    require: true
  },
  indexs: {
    type: Number
  },
  data: {
    type: Array as PropType<IPersonnel[]>
  },
  flag: {
    type: Boolean
  }
},
  emits: ['personChange'],
  setup(__props, { emit }) {

const props = __props





const store = useStore()
const value = ref('')
const checkedList = ref<IPersonnel[]>([])

const searchData = () => {
  if (value.value) {
    list.value = oldData.filter(
      (item: IPersonnel) => item.nickname.indexOf(value.value) !== -1
    )
  } else {
    list.value = JSON.parse(JSON.stringify(oldData))
  }
}

const closeItem = (person: IPersonnel) => {
  const index = checkedList.value.findIndex(
    (item: IPersonnel) => item.userId === person.userId
  )
  checkedList.value.splice(index, 1)
}

const saveData = () => {
  emit('personChange', props.type, checkedList.value, props.indexs)
}

const checkItem = (person: IPersonnel) => {
  const index = checkedList.value.findIndex(
    (item: IPersonnel) => item.userId === person.userId
  )
  if (index === -1) {
    checkedList.value.push(person)
  }
}

const list = ref<IPersonnel[] | null>(null)
let oldData: IPersonnel[] = []

const getData = async () => {
  const params = {
    thirdTenantId: store.getters.thirdTenantId,
    templateId: props.templateId,
    storeNo: props.storeNo,
    page: 1,
    size: 300
  }
  let res: any
  if (props.type === '1') {
    res = await fetchRectifyUserPage(params)
  } else if (props.type === '2') {
    res = await fetchReviewUserPage(params)
  } else {
    res = await fetchCopyUserPage(params)
  }

  list.value = res.rows
  oldData = JSON.parse(JSON.stringify(res.rows))
}

watch(
  () => props.flag,
  (newVal: any) => {
    if (newVal) {
      checkedList.value = JSON.parse(JSON.stringify(props.data))
      getData()
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: value.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        searchData
      ],
      placeholder: "请输入模板的名称搜索"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_cell_group, {
      inset: "",
      style: {"height":"50vh","overflow-y":"auto"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
          return (_openBlock(), _createBlock(_component_van_cell, {
            key: item.userId,
            title: `${item.nickname}（${item.roleNames?.join('、') || ''}）`,
            label: item.phone,
            onClick: ($event: any) => (checkItem(item))
          }, null, 8, ["title", "label", "onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    (list.value?.length === 0)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          description: "没有数据"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkedList.value, (item) => {
          return (_openBlock(), _createBlock(_component_van_tag, {
            key: item.userId,
            show: true,
            closeable: "",
            size: "large",
            type: "warning",
            style: {"margin":"4px"},
            onClose: ($event: any) => (closeItem(item))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.nickname), 1)
            ]),
            _: 2
          }, 1032, ["onClose"]))
        }), 128))
      ]),
      _createVNode(_component_van_button, {
        class: "btn-areas-save",
        type: "primary",
        onClick: saveData
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}
}

})